import { AxiosResponse } from "axios";

import { DAO, DAO_SESHAT } from "@/api/DAO";
import {
  PRODUCT_DETAILS_URL,
  PRODUCT_FEATURE_URL,
  PRODUCT_IMG_URL,
  PRODUCT_SUMMARIES_URL,
  PRODUCTS_URL
} from "@/api/URL-constants";

import { PRODUCT } from "@/constants/product.constants";

import {
  CreateProductResponse,
  GetProductResponse,
  GetProductSummaryResponse,
  ProductFeatureToUpdate,
  ProductToCreate,
  ProductToUpdate
} from "@/models/api/product.model";
import { ProductItem, ProductSummaryItem } from "@/models/product.model";

const getAll = (): Promise<ProductSummaryItem[] | void> => {
  return DAO_SESHAT()
    .get(PRODUCT_SUMMARIES_URL)
    .then((response: AxiosResponse<GetProductSummaryResponse>) => {
      return response.data.data;
    })
    .catch(error => {
      throw error;
    });
};

const get = (productId: number): Promise<ProductItem> => {
  return DAO_SESHAT()
    .get(`${PRODUCT_DETAILS_URL}/${productId}`)
    .then((response: AxiosResponse<GetProductResponse>) => {
      if (response.status === 200) {
        if (Array.isArray(response.data.data)) {
          throw new Error(PRODUCT.ERRORS.notFound);
        }
        return response.data.data;
      } else {
        throw new Error(PRODUCT.ERRORS.loading);
      }
    });
};

const create = (
  payload: ProductToCreate
): Promise<AxiosResponse<CreateProductResponse>> => {
  return DAO_SESHAT().post(PRODUCTS_URL, payload);
};

const update = (payload: ProductToUpdate): Promise<AxiosResponse> => {
  return DAO_SESHAT().put(PRODUCTS_URL, payload);
};

const remove = (productId: number): Promise<AxiosResponse> => {
  return DAO_SESHAT().delete(`${PRODUCTS_URL}/${productId}`);
};

const addImage = (payload: FormData): Promise<AxiosResponse> => {
  return DAO_SESHAT().post(PRODUCT_IMG_URL, payload, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

const updateFeature = (
  payload: ProductFeatureToUpdate
): Promise<AxiosResponse> => {
  return DAO().put(PRODUCT_FEATURE_URL, payload);
};

export { getAll, get, create, update, remove, addImage, updateFeature };
